declare namespace $ {

	type $mol_text__text_bog_quiz_session_host_1 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['state_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_major__title_bog_quiz_session_host_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_link__uri_bog_quiz_session_host_3 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['join_uri'] >
		,
		ReturnType< $mol_link['uri'] >
	>
	type $mol_link__sub_bog_quiz_session_host_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_section__title_bog_quiz_session_host_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_quiz_session_host_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_list__rows_bog_quiz_session_host_7 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['participant_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_section__title_bog_quiz_session_host_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_quiz_session_host_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_button_major__click_bog_quiz_session_host_10 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['start'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__title_bog_quiz_session_host_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_bog_quiz_session_host_12 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['can_start'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_bog_quiz_session_host_13 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['next'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__title_bog_quiz_session_host_14 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['next_button_title'] >
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_bog_quiz_session_host_15 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['can_next'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_minor__click_bog_quiz_session_host_16 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['end'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_bog_quiz_session_host_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_bog_quiz_session_host_18 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['can_end'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_row__sub_bog_quiz_session_host_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_section__title_bog_quiz_session_host_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_bog_quiz_session_host_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	type $mol_text__text_bog_quiz_session_host_22 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['participant_status_text'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_view__sub_bog_quiz_session_host_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_card__title_bog_quiz_session_host_24 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['participant_name'] >
		,
		ReturnType< $mol_card['title'] >
	>
	type $mol_card__Content_bog_quiz_session_host_25 = $mol_type_enforce<
		ReturnType< $bog_quiz_session_host['Participant_content'] >
		,
		ReturnType< $mol_card['Content'] >
	>
	export class $bog_quiz_session_host extends $mol_page {
		session_title( ): string
		state_text( ): string
		State_info( ): $mol_text
		join_uri( ): string
		Join_button( ): $mol_button_major
		Join_link( ): $mol_link
		Status_section( ): $mol_section
		participant_rows( ): readonly(any)[]
		Participants( ): $mol_list
		Participants_section( ): $mol_section
		start( next?: any ): any
		can_start( ): boolean
		Start_button( ): $mol_button_major
		next( next?: any ): any
		next_button_title( ): string
		can_next( ): boolean
		Next_button( ): $mol_button_major
		end( next?: any ): any
		can_end( ): boolean
		End_button( ): $mol_button_minor
		Controls( ): $mol_row
		Controls_section( ): $mol_section
		participant_name( id: any): string
		participant_status_text( id: any): string
		Participant_status( id: any): $mol_text
		Participant_content( id: any): $mol_view
		session_id( ): string
		title( ): ReturnType< $bog_quiz_session_host['session_title'] >
		body( ): readonly(any)[]
		Participant_card( id: any): $mol_card
	}
	
}

//# sourceMappingURL=host.view.tree.d.ts.map